import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function loadUnits() {
    return {
        index,
        get,
        save,
        receiptsAvailable,
        whrecAvailable,
        guidesAvailable,
        addItem,
        addItemByScan,
        removeItem,
        addReceipts,
        addImage,
        removeImage,
        deleteLoadUnit,
        closeLoadUnit,
        reopenLoadUnit,
        deliveryLoadUnit,
        revertDeliveryLoadUnit,
        getInvoices,
        printLabel,
        printCustomLabel,
        exportLoadUnitFile
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`loadunit/search${params}`);
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.patch('loadunit/update', payload);
        } else {
            return axiosInstance.post('loadunit/create', payload);
        }
    }

    function get(id) {
        return axiosInstance.get(`loadunit/get?id=${id}`);
    }

    function addItem(payload) {
        return axiosInstance.post('loadunit/add-items', payload);
    }

    function addReceipts(payload) {
        return axiosInstance.post('loadunit/add-receipts', payload);
    }

    function removeItem(payload) {
        return axiosInstance.delete('loadunit/remove-items', {
            data: JSON.stringify(payload)
        });
    }

    function receiptsAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`loadunit/available-receipts${params}`);
    }

    function whrecAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`loadunit/available-warehouses${params}`);
    }

    function guidesAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`loadunit/available-guides${params}`);
    }

    function addImage(image, id) {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('id', id);

        return axiosInstance.post('loadunit/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(id, imageId) {
        return axiosInstance.delete(`loadunit/delete-image`, {
            data: {
                loadunitId: id,
                imageId: imageId
            }
        });
    }

    function deleteLoadUnit(id) {
        return axiosInstance.delete(`loadunit/delete`, {
            data: id
        });
    }

    function closeLoadUnit(id) {
        return axiosInstance.post('loadunit/close', { id });
    }

    function reopenLoadUnit(id, comment) {
        return axiosInstance.post('loadunit/reopen', { id, comment });
    }

    function deliveryLoadUnit(id, comment) {
        return axiosInstance.post('loadunit/delivered', { id, comment });
    }

    function revertDeliveryLoadUnit(id) {
        return axiosInstance.post('loadunit/revert-deliverd', { id });
    }

    function exportLoadUnitFile(options = {}, type = 'pdf') {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            format: type
        };
        let params = {};
        let headers = {};

        if (type === 'pdf') {
            const args = options ? JSON.parse(options) : null;
            params = generateQueryParams(args.query, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            };
        } else {
            params = generateQueryParams(options, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer'
            };
        }
        return axiosInstance.get(`loadunit/export${params}`, headers);
    }

    function getInvoices(id) {
        return axiosInstance.get(`loadunit/bills?id=${id}`);
    }

    function printLabel(id) {
        return axiosInstance.get(`loadunit/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function printCustomLabel(id, formatId) {
        return axiosInstance.get(
            `loadunit/label-custom?id=${id}&labelFormatId=${formatId}`,
            {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    function addItemByScan(payload) {
        return axiosInstance.post('loadunit/add-item-barcode', payload);
    }
}
